<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>dynamic_form</mat-icon>
				<span>{{ formId ? 'Formularausgabe' : 'Formularerstellung' }}</span>
			</div>

			@if( bLoading ) {
				<mat-spinner diameter=20 />
			}

			<button
				mat-raised-button
				[disabled]="bQuestionCreationInProgress || bSaving"
				[routerLink]="['/Formulare']"
			>
				Zurück zu den Formularen
			</button>

		</div>

		@if( bLoading ) {
			<div style="margin: 100px auto 0 auto;">
				<mat-spinner diameter=120 />
			</div>
		}
		@else if( bLoadingError ) {
			<div class="errorWarning">
				Beim Laden des Formulars ist ein Fehler aufgetreten
			</div>
		}
		@else {

			<div class="formContainer">

				@if( bLockedForm ) {
					<div class="errorWarning" style="margin-bottom: 20px;">
						Dieses Formular wird derzeit von einigen Veranstaltungen verwendet und kann daher nicht bearbeitet werden.
					</div>
				}

				<div class="firstLine">

					<mat-form-field
						[formGroup]="formFormGroup"
						appearance="outline"
						subscriptSizing="dynamic"
					>
						<mat-label>Titel</mat-label>
						<input
							matInput
							type="text"
							formControlName="title"
						>
					</mat-form-field>

					@if( !bLockedForm ) {

						<button
							mat-flat-button
							(click)="clickAddQuestion()"
							[disabled]="bQuestionCreationInProgress"
						>
							<div class="iconAndTxt">
								<span class="material-icons">add</span>
								<span>Frage hinzufügen</span>
							</div>
						</button>
						
					}

				</div>

				<question-builder-branch
					[branch]="questionTree"
				/>


				@if( !bLockedForm ) {

					<div class="lastColumn">
	
						@if( bQuestionCreationError ) {
							<div class="errorWarning">
								Beim Hinzufügen der Frage ist ein Fehler aufgetreten
							</div>
						}
	
						@if( bFormSaveError ) {
							<div class="errorWarning">
								Beim Speichern des Formulars ist ein Fehler aufgetreten
							</div>
						}
						@else if( tmsLastSaveStart !== null ) {
							<last-save-msg
								[tmsLastSaveStart]="tmsLastSaveStart"
								[tmsLastSaveEnd]="tmsLastSaveEnd"
							/>
						}
	
					</div>

				}

			</div>

		}


	</div>

</div>




